import { Outlet } from 'react-router-dom';
import { isNewMembershipsEnabled } from '@/services/new-memberships.service';
import { NewMembershipsClosedPage } from './NewMembershipsClosedPage';

export function NewMembershipsGate() {
  if (!isNewMembershipsEnabled()) {
    return <NewMembershipsClosedPage />;
  }

  return <Outlet />;
}
